import { useEffect } from "react";
import "@/App.css";
import Lenis from "lenis";
import { Toaster } from "@/components/ui/sonner";
import Navbar from "@/components/landing/Navbar";
import Hero from "@/components/landing/Hero";
import Marquee from "@/components/landing/Marquee";
import About from "@/components/landing/About";
import Showcase from "@/components/landing/Showcase";
import Process from "@/components/landing/Process";
import Testimonials from "@/components/landing/Testimonials";
import ContactSection from "@/components/landing/ContactSection";
import Footer from "@/components/landing/Footer";

export const scrollToId = (id) => {
    if (window.__lenis) {
        window.__lenis.scrollTo(id, { offset: -72, duration: 1.4 });
    } else {
        document.querySelector(id)?.scrollIntoView({ behavior: "smooth" });
    }
};

function App() {
    useEffect(() => {
        const lenis = new Lenis({ lerp: 0.09, smoothWheel: true });
        window.__lenis = lenis;
        let rafId;
        const raf = (time) => {
            lenis.raf(time);
            rafId = requestAnimationFrame(raf);
        };
        rafId = requestAnimationFrame(raf);
        return () => {
            cancelAnimationFrame(rafId);
            lenis.destroy();
            window.__lenis = null;
        };
    }, []);

    return (
        <div className="App grain bg-[#F9F8F3]" data-testid="app-root">
            <Navbar />
            <main>
                <Hero />
                <Marquee />
                <About />
                <Showcase />
                <Process />
                <Testimonials />
                <ContactSection />
            </main>
            <Footer />
            <Toaster position="bottom-right" richColors />
        </div>
    );
}

export default App;
